// Emitted in place of a calendar block when the user hasn't connected Google or
// connected without Calendar scope.
export interface ConnectGooglePayload {
  type: "connect_google";
  provider: string;
  reason: "not_connected" | "missing_scope";
  missingScopes?: string[];
}

const REASONS: ReadonlySet<ConnectGooglePayload["reason"]> = new Set(["not_connected", "missing_scope"]);

const isReason = (v: unknown): v is ConnectGooglePayload["reason"] =>
  typeof v === "string" && REASONS.has(v as ConnectGooglePayload["reason"]);

// An unrecognized `reason` defaults to `not_connected`.
export const parseConnectGooglePayload = (v: unknown): ConnectGooglePayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "connect_google") return null;
  if (typeof r.provider !== "string") return null;
  return {
    type: "connect_google",
    provider: r.provider,
    reason: isReason(r.reason) ? r.reason : "not_connected",
    ...(Array.isArray(r.missingScopes) && r.missingScopes.every((s): s is string => typeof s === "string")
      ? { missingScopes: r.missingScopes }
      : {}),
  };
};
